export default "__VITE_ASSET__8beb7244__"